(function () {
    'use strict';

    angular.module('thankview.videoRequest')
        .controller('VideoRequestConfirmationController', ['$scope', '$document', 'vidJs', function ($scope, $document, vidJs) {
            const videoPath = config.params.video_path;
            const thumbnail = config.params.thumbnail;

            $scope.init = function () {
                var videoElement = $document[0].querySelector('#inline-video-wrapper');
                var options = {
                    image: thumbnail,
                    aspectRatio: '16:9',
                };
                vidJs.init('video-request-submission', videoPath, videoElement, options);
            };
            $scope.init();
        }]);
}());
